import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'Components/Blog/cards/BlogPostsCard.scss';

const SkeletonBlogPostCard = ({
  hideIntro,
  darkTheme,
  showDate,
}) =>
  <div
    className={classNames(
      'blog-post-card',
      { 'short-card': hideIntro },
      { 'card-dark-theme': darkTheme },
    )}
  >
    <div className="responsive-image responsive-image--16by9 blog-img-container" />
    <div className="blog-post-card-container p-3">
      <div className="blog-card-title" />
      {!hideIntro &&
        <div className="blog-card-intro-text" />
      }
    </div>
    {!hideIntro &&
      <hr className="blog-card-hr mx-3 my-0" />
    }
    {showDate &&
      <div className={classNames('blog-card-date', { 'pt-0': hideIntro })} />
    }
  </div>;

SkeletonBlogPostCard.propTypes = {
  hideIntro: PropTypes.bool,
  darkTheme: PropTypes.bool,
  showDate: PropTypes.bool,

};

SkeletonBlogPostCard.defaultProps = {
  hideIntro: false,
  darkTheme: false,
  showDate: true,
};

export default SkeletonBlogPostCard;
